<generic-card [title]="title" [descriptionTitle]="descriptionTitle" [descriptionContent]="descriptionContent" [error]="error" [isLoading]="isLoading" [ngClass]="cardClass" class="table-card">
    @if (isLoading) {
    <ed-skeleton-list></ed-skeleton-list>
    } @else {
        <div class="table-card-body">

            <div class="export-menu">
                <div mat-icon-button [matMenuTriggerFor]="menu">
                    <i class="icon icon-download"></i>
                </div>
        
                <mat-menu #menu="matMenu" class="table-dropdown">
                    <button mat-menu-item (click)="export()">Download CSV</button>
                </mat-menu>
            </div>
            <ed-table *ngIf="dataSource?.data?.length" [dataSource]="dataSource" [displayedColumns]="displayedColumns" [areActionsInElements]="areActionsInElements" (onRowClick)="onRowClickEvent($event)" (onDropdownMenuClick)="onDropdownMenuClickEvent($event)" [sortInfo]="sortInfo"
                [filter]="filter">
            </ed-table>
        </div>
    }
</generic-card>